import React from 'react';
import ImageCarousel from './ImageCarousel';

const ContentSection = ({ textContent, images, imageComponent, reverse = false }) => {
    const TextColumn = () => (
        <div className="col-lg-5">
            <div className="about-content pe-5">
                {Array.isArray(textContent) ? (
                    textContent.map((paragraph, index) => (
                        <p key={index} className="text-body-small">{paragraph}</p>
                    ))
                ) : (
                    <p className="text-body-small">{textContent}</p>
                )}
            </div>
        </div>
    );

    const ImageColumn = () => (
        <div className="col-lg-7">
            <div className="about-image-gallery">
                {images ? (
                    <ImageCarousel images={images} />
                ) : imageComponent ? (
                    imageComponent
                ) : null}
            </div>
        </div>
    );

    // Always return text on left, image on right
    return (
        <>
            <TextColumn />
            <ImageColumn />
        </>
    );
};

export default ContentSection; 